// Date Helpers
// NB - deprecated all these date functions, partly since they extend native objects, and we should make use of date-fns. (Olly)
// date-fns format options: https://date-fns.org/v2.0.1/docs/format

import {
  regionOptions
  /* languageOptions, */
} from "@/store/constants"
import { getCurrentInstance } from "vue"

/**
 * Convert public_id in a Contentful/Cloudinary image object to a transformation-friendly format
 * @param {Object} imageObj - The image object to use
 */
export function cloudinaryPublicIdForTransformation(imageObj) {
  if (imageObj) {
    const regex = /\//g
    return imageObj.public_id.replace(regex, ":")
  }
}

// returns { countryCode, store, market, language, countryPath, languagePath }
export function getStoreConfig(countryCode, languageCandidate, localeOptions) {
  Bleach.debug.log(
    "getStoreConfig",
    "|   countryCode:",
    countryCode,
    "|   languageCandidate:",
    languageCandidate
  )

  const { store, market } = getStoreAndMarketFromCountryCode(
    countryCode,
    localeOptions
  )

  let language, countryPath, languagePath

  countryPath =
    countryCode.toUpperCase() !== "GB" ? countryCode.toLowerCase() : null

  // if there is a language declared
  // if it's the default language for the market, then language becomes null
  // if it's another supported language, then set the language to that

  const matchingRegionConfig = regionOptions.find(
    region => region?.countryCode?.toUpperCase() == countryCode?.toUpperCase()
  )

  // console.log("matchingRegionConfig", matchingRegionConfig)

  if (
    languageCandidate &&
    matchingRegionConfig?.language &&
    languageCandidate == matchingRegionConfig?.language
  ) {
    languagePath = null
    language = null
  } else if (
    matchingRegionConfig?.supportedLanguages?.includes(languageCandidate)
  ) {
    languagePath = languageCandidate
    language = languageCandidate
  } else {
    languagePath = null
    language = "en-GB"
  }

  return {
    countryCode: countryCode.toUpperCase(),
    market,
    store,
    language,
    countryPath,
    languagePath
  }
}

// export function getMarketMeta(market, metafieldKey) {
//   return market?.metafield?.key === metafieldKey && market.metafield.value
// }

function getStoreAndMarketFromCountryCode(countryCode, localeOptions) {
  const store = localeOptions.find(store => {
    return store?.markets?.nodes.some(market => {
      return market?.conditions?.regionsCondition?.regions?.nodes.some(
        region => region?.code == countryCode.toUpperCase()
      )
    })
  })

  const market = store?.markets?.nodes.find(market => {
    return market?.conditions?.regionsCondition?.regions?.nodes.some(
      region => region?.code == countryCode.toUpperCase()
    )
  })
  return { store, market }
}

// returns { countryCode, store, market, language, countryPath, languagePath }
export function parseStoreConfigFromUrl(pathname, localeOptions = []) {
  let countryCode, language, countryPath, languagePath

  if (pathname) {
    const pathSegments = pathname.split("/").filter(Boolean) // ["nl", "en-GB", "example-product-path"]

    for (const region of regionOptions) {
      const regionCode = region.countryCode.toLowerCase()

      if (regionCode !== "gb") {
        // Check for valid countryPath → must match first segment
        if (pathSegments[0] === regionCode) {
          countryPath = regionCode

          // Check if next segment is a supported language
          const langCandidate = pathSegments[1]
          if (langCandidate && region.language == langCandidate) {
            // The path has a language component but it's the same as the default language (edge case; we should never generate such URLs)
            Bleach.debug.log(
              "Path has language component, same as default language",
              region.language
            )
            language = langCandidate
            languagePath = null
          } else if (
            region.supportedLanguages?.includes(langCandidate) ||
            langCandidate == "en"
          ) {
            // The path has a language component which is one of the supported languages for this region
            Bleach.debug.log(
              "Path has language component, valid supported language",
              langCandidate
            )
            language = langCandidate == "en" ? "en-GB" : langCandidate
            languagePath = langCandidate
          } else if (region.language) {
            // The path has no language component, but there is a default language so we should use that, without a languagePath
            Bleach.debug.log(
              "Path has NO language component, using regional language:",
              region.language
            )
            language = region.language
            languagePath = null
          } else {
            // The path has no language component, so the default (English) is used
            Bleach.debug.log(
              "Path has NO language component, and NO regional language:"
            )
            language = "en-GB"
            languagePath = null
          }

          countryCode = region.countryCode
        }
      } else if (regionCode == "gb") {
        // Market with no prefix (UK)
        // Match if the first segment is NOT a known prefix
        const otherRegions = regionOptions.map(region =>
          region?.countryCode?.toLowerCase()
        )

        Bleach.debug.log("regionCode == gb", otherRegions)

        if (!otherRegions.includes(pathSegments[0])) {
          language = "en-GB"
          languagePath = null

          // Check if first segment is a supported language
          const langCandidate = pathSegments[0]
          if (region.supportedLanguages?.includes(langCandidate)) {
            language = langCandidate
            languagePath = langCandidate
          }

          countryCode = region.countryCode.toUpperCase()
        }
      }
    }
  }

  const { store, market } = getStoreAndMarketFromCountryCode(
    countryCode,
    localeOptions
  )

  return { countryCode, language, store, market, countryPath, languagePath }
}

export function formatPrice(price, localeData = {}, quantity = 1) {
  const { language, market } = localeData

  let cents

  if (typeof price === "object" && price !== null) {
    cents = price.cents * quantity
  } else if (typeof price == "number") {
    cents = price * quantity
  } else if (typeof price == "string") {
    cents = parseFloat(price) * quantity
  }

  return new Intl.NumberFormat(language || market.defaultLanguage, {
    minimumFractionDigits: cents % 100 == 0 ? 0 : 2,
    maximumFractionDigits: cents % 100 == 0 ? 0 : 2,
    style: "currency",
    currency: market?.currencySettings?.baseCurrency?.currencyCode || "GBP",
    currencyDisplay: "narrowSymbol"
  }).format(cents / 100)
}

export function navigateOnMap(lat, long) {
  // If it's an iPhone..
  if (
    navigator.platform.indexOf("iPhone") !== -1 ||
    navigator.platform.indexOf("iPod") !== -1
  ) {
    var ver = [0]

    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later
      var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)
      ver = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
    }

    var protocol = "http://"
    if (ver[0] >= 6) {
      protocol = "maps://"
    }
    window.location =
      protocol + "maps.apple.com/maps?daddr=" + lat + "," + long + "&amp;ll="
  } else {
    window.open("http://maps.google.com?daddr=" + lat + "," + long + "&amp;ll=")
  }
}

export function camelToSnake(key) {
  return key
    .split("")
    .map((char, index) => {
      if (index !== 0 && char == char.toUpperCase()) {
        return "_" + char.toLowerCase()
      } else {
        return char
      }
    })
    .join("")
}

export function generatePassword(length = 8) {
  var charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
    retVal = ""
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }
  return retVal
}

export function prefixedSlug(prefix = undefined, slug = undefined) {
  if (!slug || typeof slug !== "string") return undefined

  return `${prefix ? prefix + "/" : ""}${slug}`
}

export function validateEmail(email) {
  if (
    /* eslint-disable */
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    )
  ) {
    return true
  }
  return false
}

export function isDarkColour(inputColour) {
  if (!inputColour) return false
  // Variables for red, green, blue values
  var r, g, b, hsp

  // Check the format of the color, HEX or RGB?
  if (inputColour.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    inputColour = inputColour.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    )

    r = color[1]
    g = color[2]
    b = color[3]
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    inputColour = +(
      "0x" +
      inputColour.slice(1).replace(inputColour.length < 5 && /./g, "$&$&")
    )

    r = inputColour >> 16
    g = (inputColour >> 8) & 255
    b = inputColour & 255
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 180) {
    return false
  } else {
    return true
  }
}

export function waitForScrollEnd(timeout = 2000) {
  return new Promise(resolve => {
    // Modern browsers
    if ("onscrollend" in window) {
      const handler = () => {
        window.removeEventListener("scrollend", handler)
        resolve()
      }
      window.addEventListener("scrollend", handler)
      return
    }

    // Fallback: detect scroll idle
    let lastScrollY = window.scrollY
    let idleTimer = null
    const start = Date.now()

    const checkIdle = () => {
      const currentY = window.scrollY

      if (currentY !== lastScrollY) {
        lastScrollY = currentY
        idleTimer = setTimeout(checkIdle, 100)
      } else {
        resolve()
      }

      if (Date.now() - start > timeout) {
        resolve()
      }
    }

    idleTimer = setTimeout(checkIdle, 100)
  })
}

export default {
  cloudinaryPublicIdForTransformation,
  navigateOnMap,
  camelToSnake,
  generatePassword,
  getStoreConfig,
  parseStoreConfigFromUrl,
  prefixedSlug,
  validateEmail,
  isDarkColour
}

// Vue 2.7 doesn't have a useStore composable for composition API,
// so we can make our own (basic) version.
export const useStore = () => {
  const vm = getCurrentInstance()
  if (!vm) {
    throw new Error("must be called in setup")
  }
  return vm.proxy.$store
}
